import React, {useState} from 'react';
import { Modal } from "react-bootstrap";
import parse from 'html-react-parser';
import { SELECTED_LANG } from '../../services/common/Constants';
import { getItemOfSessionStorage } from '../../services/common/utils';
import { useQuery } from 'react-query';
import PageShimmer from '../../components/loader/skeletons/common/page-shimmer';
import { CDR_TandC } from '../../services/common/endpoints';

const SupportModal = ({
  show,
  toggleModal,
  title = '',
  segmentId=''
}) => {
  const lang = getItemOfSessionStorage(SELECTED_LANG);
  const [productDetails, setProductDetails] = useState('');
  const selectedlang = getItemOfSessionStorage(SELECTED_LANG);
  const {data: {data}={}} = useQuery([{}, CDR_TandC,
  {   
    "segmentid":segmentId,
    "iseshop":"false",
    "childlineflag":"false"
  },
  {"langcookie": lang}
],
  {
    staleTime: 0,
    cacheTime: 0,
    onSuccess: ({data: udata}) =>{
      if(udata?.status !== "-1"){
        if(udata?.response){
          setProductDetails(udata?.response[0]?.ProductDetails)
        }
      }
    }
  })


  return (
    <Modal
      show={show}
      backdrop="true"
      className="modal animated slideInUp faster popup2 country-accro-comp1 p-0 sprint16-modal-popup sp16-terms-pop"
      onHide={toggleModal}
    >
      {data ?
      <>
      <Modal.Header className="border-0">
        <h6 class="dir-ltrl"></h6>
        <button className="badges-close-button">
          <img
            onClick={toggleModal}
            src={process.env.PUBLIC_URL + "/assets/images/cross_dark.svg"}
            alt=""
            title=""
          />
        </button>
      </Modal.Header>
      <Modal.Body >
        <div className='sprint16-terms-popup '>
          <h6 className='terms-title text-center '>{ selectedlang === "en" ? productDetails?.ProductTitle : productDetails?.ProductTitle_ar}</h6>
          <div className='sprint16-terms-content'>
            <div>{parse(productDetails?.summary)}</div>
          </div>
        </div>
      </Modal.Body>
      </>: <PageShimmer/>}
    </Modal>
  );

};
export default SupportModal;
